import { getQueue, getCompanies, getMeters, getBatchDetail, saveQueueItem, start, cancel, count, getMeterDetail, getMeterVolumetric } from '@/api/queue'
import { getChartImage } from '@/api/chartImage'
import * as mutations from '../mutation-types.js'

const queue = {
  state: {
    queue: [{}],
    currentQueueItem: {
      excludeFromAutoIntegration: false,
      isRotary: false,
      indexOn: null,
      indexOff: null,
      isNilChart: false
    },
    currentImage: {},
    meters: [],
    currentCompany: {},
    currentMeter: {},
    currentCompanies: [],
    fetchingCompanies: false,
    loadingMore: false,
    fetchingMeters: false,
    dateOn: '',
    timeOn: '',
    dateOff: '',
    timeOff: '',
    batchDetail: {},
    queuePage: 0,
    queueMaxPage: null,
    isSaveError: false,
    saveStatus: '',
    meterDetail: {},
    isSaving: false,
    meterVolumetric: {},
    currentQueueIndex: 0
  },
  mutations: {
    [mutations.SET_QUEUE_ITEM] (state, currentQueueItem) {
      state.currentQueueItem = currentQueueItem
    },
    SET_QUEUE: (state, queue) => {
      state.queue = queue
    },
    SET_CHART_IMAGE: (state, chartImage) => {
      state.currentImage = chartImage
    },
    [mutations.SET_COMPANIES] (state, companies) {
      state.currentCompanies = companies
    },
    [mutations.SET_METERS] (state, streams) {
      state.meters = streams
    },
    [mutations.SET_CURRENT_COMPANY] (state, company) {
      state.currentCompany = company
    },
    [mutations.SET_CURRENT_METER] (state, meter) {
      state.currentMeter = meter
      if (state.currentQueueItem != null && meter != null) {
        state.currentQueueItem.meterID = meter
      }
    },
    [mutations.FETCHING_COMPANIES] (state, bStatus) {
      state.fetchingCompanies = bStatus
    },
    [mutations.LOADING_MORE] (state, bStatus) {
      state.loadingMore = bStatus
    },
    [mutations.FETCHING_METERS] (state, bStatus) {
      state.fetchingMeters = bStatus
    },
    [mutations.SET_DATE_ON] (state, dateOn) {
      state.dateOn = dateOn
      state.currentQueueItem.dateOn = dateOn
    },
    [mutations.SET_TIME_ON] (state, timeOn) {
      state.timeOn = timeOn
      state.currentQueueItem.timeOn = timeOn
    },
    [mutations.SET_DATE_OFF] (state, dateOff) {
      state.dateOff = dateOff
      state.currentQueueItem.dateOff = dateOff
    },
    [mutations.SET_TIME_OFF] (state, timeOff) {
      state.timeOff = timeOff
      state.currentQueueItem.timeOff = timeOff
    },
    [mutations.SET_BATCH_DETAIL] (state, batchDetail) {
      state.batchDetail = batchDetail
    },
    [mutations.SET_QUEUE_PAGE] (state, page) {
      state.queuePage = page
    },
    [mutations.SET_QUEUE_MAX_PAGE] (state, page) {
      state.queueMaxPage = page
    },
    [mutations.SET_SAVE_STATUS] (state, objStatus) {
      state.saveStatus = objStatus.status
      state.isSaveError = objStatus.isError
    },
    [mutations.SET_QUEUE_DATA] (state, data) {
      state.queue.data = data
    },
    [mutations.SET_METER_DETAIL] (state, meter) {
      state.meterDetail = meter
    },
    [mutations.SET_IS_SAVING] (state, isSaving) {
      state.isSaving = isSaving
    },
    [mutations.RESET_METADATA] (state) {
      state.meterDetail = {}
      state.dateOn = ''
      state.timeOn = ''
      state.dateOff = ''
      state.timeOff = ''
      state.currentMeter = null
      state.isNilChart = false
      state.currentQueueItem = {}
      state.meterVolumetric = {}
    },
    [mutations.SET_METER_VOLUMETRIC] (state, volumetric) {
      state.meterVolumetric = volumetric
    },
    [mutations.SET_NIL_CHART] (state, isNilChart) {
      if (state.currentQueueItem != null) {
        state.currentQueueItem.isNilChart = isNilChart
      }
    },
    [mutations.RESET_CURRENT_QUEUE_INDEX] (state) {
      state.currentQueueIndex = 0
    },
    [mutations.INCREMENT_CURRENT_QUEUE_INDEX] (state) {
      state.currentQueueIndex++
    },
    [mutations.SET_EXCLUDE_CHART] (state, excludeChart) {
      if (state.currentQueueItem != null) {
        state.currentQueueItem.excludeFromAutoIntegration = excludeChart
      }
    }
  },
  actions: {
    async getQueue ({ state, commit }) {
      commit(mutations.LOADING_MORE, true)
      if (state.queueMaxPage == null || state.queuePage >= state.queueMaxPage) {
        commit(mutations.SET_QUEUE_PAGE, 0)
        await this.dispatch('getQueuePageCount')
      }
      commit(mutations.SET_QUEUE_PAGE, state.queuePage + 1)
      var queue = await getQueue(state.queuePage)
      commit(mutations.SET_QUEUE, queue)
      if (queue.data.length > 0) {
        commit(mutations.RESET_CURRENT_QUEUE_INDEX)
        await this.dispatch('setQueueItem', queue.data[0])
      }
      commit(mutations.LOADING_MORE, false)
    },
    async getQueuePageCount ({ commit }) {
      await commit(mutations.SET_QUEUE_MAX_PAGE, count())
    },
    async setQueueItem ({ commit }, queueItem) {
      // start queue processing
      await this.dispatch('startQueueItem', queueItem)
      commit(mutations.SET_QUEUE_ITEM, queueItem)
      commit(mutations.SET_CHART_IMAGE, await getChartImage(queueItem.batch))
      commit(mutations.SET_SAVE_STATUS, { status: '', isError: false })
      await this.dispatch('fetchBatchDetail', queueItem.batch)
    },
    async getCompanies ({ state, commit }, search) {
      if (!state.fetchingCompanies) {
        commit(mutations.FETCHING_COMPANIES, true)
        commit(mutations.SET_COMPANIES, await getCompanies(search))
        commit(mutations.FETCHING_COMPANIES, false)
      }
    },
    async fetchMeters ({ state, commit }, search) {
      if (!state.fetchingMeters && state.currentCompany) {
        commit(mutations.FETCHING_METERS, true)
        commit(mutations.SET_METERS, await getMeters(state.currentCompany, search))
        commit(mutations.FETCHING_METERS, false)
      }
    },
    async setCurrentCompany ({ commit }, companyid) {
      commit(mutations.SET_CURRENT_COMPANY, companyid)
      commit(mutations.SET_METERS, [])
      commit(mutations.SET_CURRENT_METER, null)
    },
    async setCurrentMeter ({ commit }, meterid) {
      commit(mutations.SET_CURRENT_METER, meterid)
      await this.dispatch('fetchMeterDetail', meterid)
    },
    async setDateOn ({ commit }, dateOn) {
      commit(mutations.SET_DATE_ON, dateOn)
    },
    async setTimeOn ({ commit }, currentTime) {
      commit(mutations.SET_TIME_ON, currentTime)
    },
    async setDateOff ({ commit }, dateOff) {
      commit(mutations.SET_DATE_OFF, dateOff)
    },
    async setTimeOff ({ commit }, timeOff) {
      commit(mutations.SET_TIME_OFF, timeOff)
    },
    async saveMetadata ({ state, commit }) {
      // validate and complete queueItem
      commit(mutations.SET_IS_SAVING, true)
      var item = state.currentQueueItem
      var result = await saveQueueItem(item)
      var status = 'Save failed.'
      if (result && result.success) {
        status = 'Saved successfully.'
      }
      commit(mutations.SET_SAVE_STATUS, { status: status, isError: result.success })
      if (result && result.success) {
        commit(mutations.RESET_METADATA)
        await this.dispatch('removeCurrentItemFromQueue')
      }
      commit(mutations.SET_IS_SAVING, false)
    },
    async fetchBatchDetail ({ commit }, batch) {
      var bd = await getBatchDetail(batch)
      commit(mutations.SET_BATCH_DETAIL, bd)
      commit(mutations.SET_COMPANIES, [{ id: bd.company_ID, name: bd.company_Name }])
      await this.dispatch('setCurrentCompany', bd.company_ID)
    },
    // Starts reading the queueItem
    async startQueueItem ({ state, commit }, queueItem) {
      var result = await start(queueItem.id)
      if (result !== null && !result) {
        await this.dispatch('getQueue')
      }
    },
    // releases item from queue
    async cancelMetadata ({ state, commit }) {
      await cancel(state.currentQueueItem.id)
      commit(mutations.RESET_METADATA)
      if (state.queue.data.length > state.currentQueueIndex + 1) {
        await this.dispatch('setQueueItem', state.queue.data[state.currentQueueIndex + 1])
        commit(mutations.INCREMENT_CURRENT_QUEUE_INDEX)
      }
    },
    async removeCurrentItemFromQueue ({ state, commit }) {
      await this.dispatch('getQueue')
    },
    async fetchMeterDetail ({ commit }, meterID) {
      var meter = await getMeterDetail(meterID)
      var vols = await getMeterVolumetric(meterID)
      commit(mutations.SET_METER_DETAIL, meter)
      commit(mutations.SET_METER_VOLUMETRIC, vols)
    },
    async setIsNilChart ({ commit }, isNilChart) {
      commit(mutations.SET_NIL_CHART, isNilChart)
    },
    async setExcludeChart ({ commit }, excludeChart) {
      commit(mutations.SET_EXCLUDE_CHART, excludeChart)
    }
  }
}

export default queue
